import { Injectable } from '@angular/core';
import { AIPService } from '../aip.service';
import { Observable, map, tap } from 'rxjs';
import { API } from 'src/app/constants/paths';
import { ApiResponse } from 'src/app/interfaces/api';
import {
  PaymentInstructionModel,
  PaymentStatus,
  PayWithWalletRequestModel,
  VerifyHandshakeResponseModel,
} from 'src/app/interfaces/payment';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends AIPService {
  private readonly paymentBaseURL = API.PAYMENT_SERVICE_HOST;

  private readonly authServiceBaseURL = API.AUTH_SERVICE_HOST;

  private _authToken = '';

  get authToken() {
    return this._authToken;
  }

  private setAuthToken(token: string) {
    this._authToken = token;
  }

  getInstructions(
    reference: string,
    paymentMethod?: string
  ): Observable<PaymentInstructionModel> {
    let params = new HttpParams();
    if (paymentMethod) {
      params = params.set('paymentMethod', paymentMethod);
    }

    const endpoint =
      this.paymentBaseURL + API.routes.payments.instructions(reference);
    return this.http
      .get<ApiResponse<PaymentInstructionModel>>(endpoint, { params })
      .pipe(map(response => new PaymentInstructionModel(response.data)));
  }

  updatePaymentMethod(
    reference: string,
    paymentMethod: string
  ): Observable<PaymentInstructionModel> {
    const endpoint =
      this.paymentBaseURL + API.routes.payments.updatePaymentMethod(reference);
    return this.http
      .patch<PaymentInstructionModel>(endpoint, {
        paymentMethod,
      })
      .pipe(map(response => new PaymentInstructionModel(response)));
  }

  getStatus(reference: string): Observable<PaymentStatus> {
    const endpoint =
      this.paymentBaseURL + API.routes.payments.status(reference);
    return this.http
      .get<ApiResponse<PaymentStatus>>(endpoint)
      .pipe(map(response => response.data));
  }

  getPaymentStatus(ref: string) {
    const endpoint = this.paymentBaseURL + API.routes.payments.status(ref);
    return this.http
      .get<ApiResponse<PaymentStatus>>(endpoint)
      .pipe(map(response => response.data));
  }

  payWithWallet(payload: PayWithWalletRequestModel) {
    const endpoint = this.paymentBaseURL + API.routes.payments.payWithWallet;

    return this.http
      .post<{ status: boolean; message: string }>(endpoint, payload)
      .pipe(map(response => response));
  }

  authenticateSession(token: string) {
    const endpoint =
      this.authServiceBaseURL + API.routes.auth.verifyHandshakeToken(token);
    return this.http
      .get<ApiResponse<VerifyHandshakeResponseModel>>(endpoint)
      .pipe(
        tap(response => {
          this.setAuthToken(response.data.access ?? '');
        })
      );
  }
}
